import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { SUPPORTED_LOCALES } from '../../i18n'
import { setApiLocale } from '../../lib/api/client'
import type { Locale } from '../../lib/api/types'
import { cn } from '../../lib/cn'

export function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const { locale } = useParams()

  function change(next: Locale) {
    i18n.changeLanguage(next)
    setApiLocale(next)
    window.localStorage.setItem('gsm_locale', next)
    // swap the locale segment in the URL, keep the rest of the path
    const parts = window.location.pathname.split('/').filter(Boolean)
    if (parts[0] && SUPPORTED_LOCALES.includes(parts[0] as Locale)) parts[0] = next
    else parts.unshift(next)
    navigate('/' + parts.join('/'))
  }

  return (
    <div className="flex h-9 items-center gap-0.5 rounded-full bg-ink-100/80 p-1">
      {SUPPORTED_LOCALES.map((l) => (
        <button
          key={l}
          onClick={() => change(l)}
          className={cn(
            'flex h-7 items-center rounded-full px-2.5 text-xs font-semibold uppercase transition',
            (locale ?? i18n.language) === l ? 'bg-white text-ink-900 shadow-sm' : 'text-ink-500 hover:text-ink-800',
          )}
        >
          {l}
        </button>
      ))}
    </div>
  )
}
